export default __webpack_public_path__ + "aa6fbca435679f967cc83993f9e52631.svg";